import flatpickr from 'flatpickr'
import { Japanese } from 'flatpickr/dist/l10n/ja.js'

document.addEventListener('turbo:load', () => {
  flatpickr('.js-flatpickr', {
    locale: Japanese,
    dateFormat: 'Y/m/d',
  })
})
